// ENG-027: the three-choice conversation rating. Stored on the existing 1..5 scale
// (Bad = 1, Fine = 3, Good = 5) with rating_scale: 3.
// ENG-028: analytics read every stored rating on the same three steps (see labelForRating).

export type RatingLabel = "bad" | "fine" | "good";

export const RATING_LABELS: readonly RatingLabel[] = ["bad", "fine", "good"];

export const RATING_LABEL_VALUES: Record<RatingLabel, number> = { bad: 1, fine: 3, good: 5 };

export const RATING_LABEL_COPY: Record<RatingLabel, { el: string; en: string }> = {
    bad: { el: "Κακή", en: "Bad" },
    fine: { el: "Εντάξει", en: "Fine" },
    good: { el: "Καλή", en: "Good" }
};

export const isRatingLabel = (value: unknown): value is RatingLabel => typeof value === "string" && (RATING_LABELS as readonly string[]).includes(value);

// ENG-028: how analytics read a stored rating — 1, 2 -> bad; 3 -> fine; 4, 5 -> good.
// Same table as LABEL_BY_RATING in gateway/services/rating_scale.py (checked by
// tests/test_rating_scale.py). Old documents without a rating count by feedback_type.
export const LABEL_BY_RATING: Readonly<Record<number, RatingLabel>> = { 1: "bad", 2: "bad", 3: "fine", 4: "good", 5: "good" };

export const LEGACY_POSITIVE_FEEDBACK_TYPE = "positive";

export const labelForRating = (rating: number | null | undefined, feedbackType?: string | null): RatingLabel | null => {
    if (rating != null) return LABEL_BY_RATING[rating] ?? null;
    if (feedbackType == null) return null;
    return feedbackType === LEGACY_POSITIVE_FEEDBACK_TYPE ? "good" : "bad";
};

export type RatingCounts = Record<RatingLabel, number>;

export const formatGoodShare = (share: number | null | undefined): string => (share == null ? "—" : `${Math.round(share * 100)}%`);

// Reasons offered after "Bad" (multiple choice). The ids are what gets stored.
export const REASON_TAGS = ["wrong_product", "missing_info", "slow", "other"] as const;
export type ReasonTag = (typeof REASON_TAGS)[number];

export const REASON_TAG_COPY: Record<ReasonTag, { el: string; en: string }> = {
    wrong_product: { el: "Λάθος προϊόν", en: "Wrong product" },
    missing_info: { el: "Έλειπε στοιχείο", en: "Missing information" },
    slow: { el: "Αργό", en: "Slow" },
    other: { el: "Άλλο", en: "Other" }
};

export const isReasonTag = (value: unknown): value is ReasonTag => typeof value === "string" && (REASON_TAGS as readonly string[]).includes(value);
